module.exports = __webpack_public_path__ + "img/krotoski_logo_grey.50f0bb52.svg";